module.exports = __webpack_public_path__ + "static/media/projectSS.f568a3a4.png";